import React, { useState, useEffect } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AuthService } from '../../../Auth/AuthService';
import Message from '../Common/Message';

const Login: React.FC<RouteComponentProps> = ({ location }) => {
  const [error, setError] = useState(false);
  const [returnUrl, setReturnUrl] = useState({});

  useEffect(() => {
    const state: any = location.state;
    if (state.from) {
      const returnUrl: string = (location.state as any).from;
      setReturnUrl(returnUrl);
    }

    try {
      AuthService.login({
        state: returnUrl
      });
    } catch (err) {
      setError(true);
    }
  }, [location, location.state, returnUrl]);

  if (error) {
    return <Redirect to='/identity-error' />;
  }

  return <Message content='Redirecting to identity provider...' />;
};

export default Login;
